import React from "react";
import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
// import dsclogo from "../resources/images/logo.png";
import "../styles/style.css";
import Toggler from "./DarkModeToggler";

export default function Nav({ mainRef }) {
  const [navbar, setNavbar] = useState(false);
  const changeBackground = () => {
    if (window.scrollY > 66) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  window.addEventListener("scroll", changeBackground);
  return (
    <header
      className={`lg:px-16 mt-0 mb-3 px-6 flex flex-wrap items-center lg:py-0 py-2 fixed w-screen z-20 nav-sun dark:nav-moon ${
        navbar ? "shadow-lg opacity-95" : ""
      }`}
      style={{ zIndex: 1000 }}
    >
      <div className="navbar flex-1 flex justify-between items-center">
        {/* <Link to="/" className="w-full h-full"> */}
        <Link to="/" className="logo-sun dark:logo-moon" />
        {/* </Link> */}
        <Toggler />
      </div>
      <label
        htmlFor="menu-toggle"
        className="pointer-cursor lg:hidden block px-3"
      >
        <svg
          className="fill-current text-gray-900 dark:text-white"
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="40"
          viewBox="0 0 20 20"
        >
          <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"></path>
        </svg>
      </label>
      <input className="hidden" type="checkbox" id="menu-toggle" />
      <div
        className="hidden lg:flex lg:items-center lg:w-auto w-full"
        id="menu"
      >
        <nav className="">
          <ul className="lg:flex items-center justify-between text-white-700 pt-4 lg:pt-0">
            <li className="text-bold md:m-4 lg:p-4 py-3 px-0 border-b-2 border-transparent text-xl font-serif hover:text-red-700 dark:hover:text-red-700 dark:text-white">
              <NavLink exact to="/" activeClassName="navbar-active">
                Home
              </NavLink>
            </li>
            <li className="text-bold md:m-4 lg:p-4 py-3 px-0 border-b-2 border-transparent text-xl font-serif hover:text-red-700 dark:hover:text-red-700 dark:text-white">
              <NavLink exact to="/team" activeClassName="navbar-active">
                Team
              </NavLink>
            </li>
            {/* <li className="text-bold md:m-4 lg:p-4 py-3 px-0 border-b-2 border-transparent text-xl font-serif hover:text-red-700 dark:hover:text-red-700 dark:text-white">
              <NavLink exact to="/projects" activeClassName="navbar-active">
                Projects
              </NavLink>
            </li> */}
            <li className="text-bold md:m-4 lg:p-4 py-3 px-0 border-b-2 border-transparent text-xl font-serif hover:text-red-700 dark:hover:text-red-700  dark:text-white">
              <NavLink exact to="/events" activeClassName="navbar-active">
                Events
              </NavLink>
            </li>
            <li className="text-bold md:m-4 lg:p-4 py-3 px-0 border-b-2 border-transparent text-xl font-serif hover:text-red-700 dark:hover:text-red-700  dark:text-white">
              <NavLink exact to="/contact" activeClassName="navbar-active">
                Contact
              </NavLink>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
}
